class GiftWrapToggle extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="checkbox"]');
    this.input.addEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    event.stopPropagation();

    const cartItems = this.closest('cart-drawer-items') || this.closest('cart-items');
    if (!cartItems) return;

    const line = this.dataset.line;
    const quantity = parseInt(this.dataset.quantity, 10);
    const properties = {
      'Presentförpackning': this.input.checked ? 'Tillagd' : '',
    };

    const sections = cartItems.getSectionsToRender().map((section) => section.section);
    const body = JSON.stringify({
      line,
      quantity,
      properties,
      sections,
      sections_url: window.location.pathname,
    });

    this.input.disabled = true;
    cartItems.enableLoading(line);

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        if (parsedState.errors) {
          this.input.checked = !this.input.checked;
          return;
        }
        cartItems.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = cartItems.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items' });
      })
      .catch(() => {
        this.input.checked = !this.input.checked;
      })
      .finally(() => {
        cartItems.disableLoading(line);
      });
  }
}

customElements.define('gift-wrap-toggle', GiftWrapToggle);
